import { useAppDispatch, useAppSelector } from "@app/hooks";
import { LInputField } from "@components/LInputField";
import { DefaultErrorMessages } from "@helpers/formValidationHelper";
import { yupResolver } from "@hookform/resolvers/yup";
import { useModal } from "@services/ModalContext";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { number, object, SchemaOf, string } from "yup";
import { ExamineeContactInfo, NewExamineeStepNames, updateContactInfo } from "../../store/newExamineeSlice";

const formSchema: SchemaOf<ExamineeContactInfo> = object({
    id: number().default(0),
    firstName: string().required(DefaultErrorMessages.required),
    lastName: string().required(DefaultErrorMessages.required),
    email: string().required(DefaultErrorMessages.required).email("Invalid email"),
    phoneNumber: string()
        .required(DefaultErrorMessages.required)
        .matches(/^\d+$/, DefaultErrorMessages.numeric("Phone number"))
        .length(10, DefaultErrorMessages.lengthDigits(10, "Phone number"))
});

export const ContactInfo = (): JSX.Element => {
    const validateMethods = useForm<ExamineeContactInfo>({
        resolver: yupResolver(formSchema)
    });

    const { setFormName, onConfirm } = useModal();
    const dispatch = useAppDispatch();

    const contactInfo = useAppSelector((x) => x.newExaminee.contactInfo);

    useEffect(() => {
        setFormName?.(NewExamineeStepNames.ContactInfo);
    }, []);

    const onSubmit = (data: ExamineeContactInfo): void => {
        dispatch(updateContactInfo(data));

        onConfirm?.();
    };

    return (
        <div className="container">
            <p className="my-2 mb-5">Please provide some necessary background information</p>

            <FormProvider {...validateMethods}>
                <form id={NewExamineeStepNames.ContactInfo} onSubmit={validateMethods.handleSubmit(onSubmit)}>
                    <div className="columns mb-0">
                        <div className="column">
                            <LInputField
                                label="First Name"
                                inputName="firstName"
                                placeholder="Enter first name"
                                defaultValue={contactInfo?.firstName}
                            />
                        </div>
                        <div className="column">
                            <LInputField
                                label="Last Name"
                                inputName="lastName"
                                placeholder="Enter last name"
                                defaultValue={contactInfo?.lastName}
                            />
                        </div>
                    </div>
                    <LInputField
                        label="Email Address"
                        inputName="email"
                        placeholder="Enter email address"
                        defaultValue={contactInfo?.email}
                    />
                    <LInputField
                        label="Phone Number"
                        inputName="phoneNumber"
                        placeholder="Enter phone number"
                        defaultValue={contactInfo?.phoneNumber}
                        maxLength={10}
                    />
                </form>
            </FormProvider>
        </div>
    );
};
